import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "./ExportLMSTable/dataSlice";

const store = configureStore({
  reducer: {
    data: dataReducer,
  },
});

export default store;
